import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { resolveInstallOrder } from '@core-engine/installable/protocol/resolve-install-order.js'
import { getPresetDefinition } from '@next-adapter/preset-registry.js'

export function resolvePresetInstallOrder(presetIds: BetterstartPresetId[]): BetterstartPresetId[] {
  return resolveInstallOrder(
    presetIds,
    (presetId) => getPresetDefinition(presetId).dependencies,
    'preset'
  )
}
